import React from 'react';
import { Menu, Leaf } from 'lucide-react';
export function Header() {
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="flex justify-between items-center h-16" data-id="element-66">
          {/* Logo Section */}
          <div className="flex items-center" data-id="element-67">
            <div className="flex items-center gap-2" data-id="element-68">
              <Leaf className="h-8 w-8 text-[#1E4D3D] fill-current" data-id="element-69" />
              <div className="flex flex-col" data-id="element-70">
                <span className="font-serif text-xl font-bold text-gray-900 leading-tight" data-id="element-71">
                  Wellness Clarity Journal
                </span>
                <span className="hidden sm:block text-xs text-gray-500 uppercase tracking-wider" data-id="element-72">
                  Your magazine for well-being, care and beauty
                </span>
              </div>
              <span className="text-xl ml-2" data-id="element-73">🇺🇸</span>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none" data-id="element-74">
            <Menu className="h-6 w-6" data-id="element-75" />
          </button>
        </div>
      </div>

      {/* Breadcrumb - visible on desktop/tablet */}
      <div className="bg-gray-50 border-b border-gray-100 py-2" data-id="element-76">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-xs text-gray-500 font-medium uppercase tracking-wide" data-id="element-77">
          Health / Alcohol Recovery / Silent Shame
        </div>
      </div>
    </header>;
}